import type { IHistoryStatus } from '@experiences/ecommerce';
import {
    Features,
    getFeatureFlagValue,
} from '@experiences/feature-flags';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import useSWR from 'swr';

import {
    billingUrl,
    fetchHistoryStatus,
} from '../../../services/licensing/BillingService';
import {
    accountLogicalName,
    isAdminSelector,
} from '../../../store/selectors';
import UiAlertBanner from '../../common/UiAlertBanner';

const useStyles = makeStyles(() =>
    createStyles({
        bannerContent: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
        },
        bannerMessage: {

            display: 'flex',
            flexDirection: 'column',
        },
    }),
);

export const EcommerceLicensePaymentPendingBanner: React.FC = () => {
    const classes = useStyles();
    const { formatMessage: translate } = useIntl();
    const currentAccountName = useSelector(accountLogicalName);
    const isAdmin = useSelector(isAdminSelector);

    const EnableEcommercePaymentElementM2 = getFeatureFlagValue(Features.EnableEcommercePaymentElementM2.name);

    const { data: ecommerceHistoryStatus } = useSWR<IHistoryStatus, Error>(
        EnableEcommercePaymentElementM2 ? [ currentAccountName, `${billingUrl}/historyStatus` ] : null,
        fetchHistoryStatus,
    );

    const shouldShowBanner = ecommerceHistoryStatus?.firstPaymentStatus === 'PAYMENT_OPEN'
        || ecommerceHistoryStatus?.incrementalPaymentStatus === 'PAYMENT_OPEN';
    const bannerMessage = () => {
        if (ecommerceHistoryStatus?.firstPaymentStatus === 'PAYMENT_OPEN') {
            return 'CLIENT_ECOMMERCE_PAYMENT_PENDING_WARNING_BANNER';
        }
        if (ecommerceHistoryStatus?.incrementalPaymentStatus === 'PAYMENT_OPEN') {
            return 'CLIENT_ECOMMERCE_INCREMENTAL_PAYMENT_PENDING_WARNING_BANNER';
        }
    };

    return (
        <>
            {
                (EnableEcommercePaymentElementM2 && isAdmin && shouldShowBanner) &&
                    <div data-cy="ui-license-payment-pending-banner">
                        <UiAlertBanner
                            type="info"
                            closeable={false}>
                            <div className={classes.bannerContent}>
                                <div className={classes.bannerMessage}>
                                    <Typography>
                                        {translate(
                                            { id: bannerMessage() })}
                                    </Typography>
                                </div>
                            </div>
                        </UiAlertBanner>
                    </div>
            }
        </>
    );
};
